/* eslint-disable react/no-unknown-property */
import Head from 'next/head';
import React from 'react';
export function HeroPreload({ imageSet, priorityOrder = ['xxl', 'l', 'm', 's', 'xs'] }) {
    const preloadKey = priorityOrder.find((key) => imageSet[key]);
    const preloadUrl = preloadKey ? imageSet[preloadKey] : null;
    if (!preloadUrl)
        return null;
    return (React.createElement(Head, null,
        React.createElement("link", { rel: "preload", as: "image", href: preloadUrl, fetchPriority: "high" })));
}
